import React, { createContext, useContext, ReactNode, useState } from 'react';

interface PreviewContextType {
  downloadUrl?: string;
  downloadFilename?: string;
  downloadTrackId?: string;
  isErrorFetchingPDF?: boolean;
  setPreviewData: (data: Omit<PreviewContextType, 'setPreviewData'>) => void;
}

const PreviewContext = createContext<PreviewContextType | undefined>(undefined);

export const PreviewProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [previewData, setPreviewData] = useState<
    Omit<PreviewContextType, 'setPreviewData'>
  >({
    downloadUrl: undefined,
    downloadFilename: undefined,
    downloadTrackId: undefined,
    isErrorFetchingPDF: undefined,
  });

  return (
    <PreviewContext.Provider value={{ ...previewData, setPreviewData }}>
      {children}
    </PreviewContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const usePreviewContext = (): PreviewContextType => {
  const context = useContext(PreviewContext);
  if (!context) {
    throw new Error('usePreviewContext must be used within PreviewProvider');
  }
  return context;
};
